import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';

/**
 *
 * This form is used for anonymous users to use a form from the landing
 * page. This will return the Entry code to the parent but not directly take them there.
 *
 */
export default function ({ onSubmit }) {
    const [entryCode, setEntryCode] = useState('');

    return (
        <Grid container justifyContent='center'>
            <Grid item xs={1} />
            <Grid item xs={10}>
                <Box p={1}>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <Grid item container alignItems='center' alignContent='center' spacing={1}>
                            <Grid item xs>
                                <TextField
                                    size='small'
                                    label='Entry Code'
                                    type='text'
                                    variant='outlined'
                                    onChange={({ target: { value } }) =>
                                        setEntryCode(value.toUpperCase())
                                    }
                                    value={entryCode}
                                />
                            </Grid>
                            <Grid item>
                                <FormControl>
                                    <Button
                                        disabled={!entryCode}
                                        variant='contained'
                                        color='primary'
                                        type='submit'
                                        onClick={() => onSubmit(entryCode)}>
                                        Proceed
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </Grid>
            <Grid item xs={1} />
        </Grid>
    );
}
